/**
 * e-Gov申請用XMLテンプレート
 * 各XMLテンプレートをエクスポートして、ストアから参照できるようにします
 */

/**
 * 取下げ依頼XML用のテンプレート
 * @returns {string} 取下げ依頼XMLテンプレート
 */
export const getTorisageiraiXmlTemplate = () => {
  return `<?xml version="1.0" encoding="UTF-8"?>
  <?xml-stylesheet href="999000000000000003.xsl" type="text/xsl"?>
  <DataRoot>
    <様式ID>999000000000000003</様式ID>
    <様式バージョン>0001</様式バージョン>
    <STYLESHEET>999000000000000003.xsl</STYLESHEET>
    <取下げ依頼情報>
      <到達番号>{{arrive_id}}</到達番号>
      <手続名称>{{proc_name}}</手続名称>
      <申請者氏名>{{requester_name}}</申請者氏名>
      <依頼年月日>
        <年>{{year}}</年>
        <月>{{month}}</月>
        <日>{{day}}</日>
      </依頼年月日>
      <理由>{{cause}}</理由>
    </取下げ依頼情報>
  </DataRoot>`
}

/**
 * 構成情報XML用のテンプレート
 * @returns {string} 構成情報XMLテンプレート
 */
export const getKouseiXmlTemplate = () => {
  return `<?xml version="1.0" encoding="UTF-8"?>
  <?xml-stylesheet href="999000000000000009.xsl" type="text/xsl"?>
  <DataRoot>
    <様式ID>999000000000000009</様式ID>
    <様式バージョン>0001</様式バージョン>
    <STYLESHEET>999000000000000009.xsl</STYLESHEET>
    <構成情報>
      <管理情報>
        <手続番号>
          <受付行政機関ID/>
          <手続ID>999000000000000003</手続ID>
        </手続番号>
        <手続名称></手続名称>
        <初回受付番号/>
        <申請種別></申請種別>
        <申請者連絡先情報>
          <申請者情報>
            <氏名></氏名>
            <氏名フリガナ></氏名フリガナ>
            <役職/>
            <法人団体名/>
            <法人団体名フリガナ/>
            <部門名/>
            <部門名フリガナ/>
            <郵便番号></郵便番号>
            <住所></住所>
            <住所フリガナ></住所フリガナ>
            <電話番号></電話番号>
            <FAX番号/>
            <電子メールアドレス></電子メールアドレス>
          </申請者情報>
          <連絡先情報>
            <氏名></氏名>
            <氏名フリガナ></氏名フリガナ>
            <役職/>
            <法人団体名/>
            <法人団体名フリガナ/>
            <部門名/>
            <部門名フリガナ/>
            <郵便番号></郵便番号>
            <住所></住所>
            <住所フリガナ></住所フリガナ>
            <電話番号></電話番号>
            <FAX番号/>
            <電子メールアドレス></電子メールアドレス>
          </連絡先情報>
          <委任登録票添付情報>
            <発行番号/>
            <委任登録票名称/>
            <委任登録票ファイル名称/>
          </委任登録票添付情報>
        </申請者連絡先情報>
      </管理情報>
      <手数料情報>
        <手数料1>
          <手数料識別子></手数料識別子>
          <略科目コード></略科目コード>
          <略科目名/>
          <振込金額></振込金額>
        </手数料1>
        <手数料2>
          <手数料識別子/>
          <略科目コード/>
          <略科目名/>
          <振込金額/>
        </手数料2>
        <手数料3>
          <手数料識別子/>
          <略科目コード/>
          <略科目名/>
          <振込金額/>
        </手数料3>
        <手数料4>
          <手数料識別子/>
          <略科目コード/>
          <略科目名/>
          <振込金額/>
        </手数料4>
        <手数料5>
          <手数料識別子/>
          <略科目コード/>
          <略科目名/>
          <振込金額/>
        </手数料5>
        <手数料6>
          <手数料識別子/>
          <略科目コード/>
          <略科目名/>
          <振込金額/>
        </手数料6>
      </手数料情報>
      <通信欄/>
      <府省照会情報>
        <府省照会1>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会1>
        <府省照会2>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会2>
        <府省照会3>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会3>
        <府省照会4>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会4>
        <府省照会5>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会5>
        <府省照会6>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会6>
        <府省照会7>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会7>
        <府省照会8>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会8>
        <府省照会9>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会9>
        <府省照会10>
          <府省照会情報ラベル></府省照会情報ラベル>
          <府省照会情報></府省照会情報>
        </府省照会10>
      </府省照会情報>
      <提出先情報>
        <提出先識別子></提出先識別子>
        <提出先名称></提出先名称>
      </提出先情報>
      <申請書属性情報>
        <申請書様式ID>999000000000000003</申請書様式ID>
        <申請書様式バージョン>0001</申請書様式バージョン>
        <申請書様式名称>取下げ依頼XML</申請書様式名称>
        <申請書ファイル名称>torisageirai.xml</申請書ファイル名称>
      </申請書属性情報>
    </構成情報>
    <その他>
      <納付関連情報>
        <納付方法/>
        <振込者氏名カナ/>
      </納付関連情報>
      <法人番号/>
    </その他>
  </DataRoot>`
}
